export const isValidUuid = (id) => {
  if (!id) return false;

  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(id);
};

export const getVerticalIdSearchFromParams = (searchParams) => {
  const verticalId = searchParams.get("verticalId");
  if (verticalId == null || verticalId === "") return "";
  return `?${new URLSearchParams({ verticalId }).toString()}`;
};

export const buildFlowSearchFromParams = (searchParams) => {
  const next = new URLSearchParams();
  const eventId = searchParams.get("eventId");
  const verticalId = searchParams.get("verticalId");
  if (eventId) next.set("eventId", eventId);
  if (verticalId != null && verticalId !== "")
    next.set("verticalId", verticalId);
  const s = next.toString();
  return s ? `?${s}` : "";
};
